<script>
  export let gameData;
  export let activeGame;
  export let formatDateTime;
  export let formatCurrencySEK;
  export let buttonsCouponInfo;
  export let toggleCouponInfo;

  let wigglingButton = null;

  function handleClick(buttonId) {
    wigglingButton = buttonId;
    setTimeout(() => wigglingButton = null, 500); // Reset after animation
  }

</script>

{#if gameData && gameData.productName[0] && gameData.productName[0].length > 0}
<div class="header {gameData.productName[0]}">
  <img src="/images/{activeGame}.svg" height="24pt" alt="{gameData.productName[0]}">
  <p>
    <img src="/images/alarmclock.svg" height="18pt" alt="Spelstopp" title="Spelstopp" /> {formatDateTime(gameData.closeTime[0])}
        <img src="/images/moneybag.svg" style="padding-left: 10pt;" height="18pt" alt="Omsättning" title="Omsättning" /> {formatCurrencySEK(gameData.oms[0])}
    {#if gameData.jp[0]}
      + <img src="/images/jackpot.svg" height="18pt" alt="Jackpot" title="Jackpot" /> {formatCurrencySEK(gameData.jp[0]).replace("milj kr", "mkr")}
    {/if}
  </p>

  <div class="couponInfo">
    {#each buttonsCouponInfo as button, index}
      <button 
        on:click={() => toggleCouponInfo(index)} 
        class="{button.active ? 'active' : 'inactive'}" 
        on:click={() => handleClick(button.name)}
      >
        <img 
          src="/images/{button.img}" 
          alt="{button.name}" 
          title="{button.name}" 
          class:wiggle={wigglingButton === button.name} 
        /> 
        <span>{button.name}</span>
      </button>
    {/each}
  </div>  
</div>
{:else}
  <div class="header">
    <p>Ingen aktiv omgång</p>
  </div>
{/if}

<style>
  /* Header styles */
.header {
  grid-column: 1 / -1; /* Spans both columns */
  background-color: #333;
  background-color: var(--themeColor1);
  color: var(--themeColorText);
  text-align: center;
  padding-top: 10px;
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 1;
}

.header p {
  padding: 0;
  margin: 7pt 0 3pt 0;
}

.header img {
  vertical-align: text-top;
/*   padding-left: 10pt; */
}

.couponInfo button {
  color: white;
}

/* .Stryktipset .couponInfo button, .Europatipset .couponInfo button {
  color: white;
}
 */
/* .Stryktipset .couponInfo button img, .Europatipset .couponInfo button img, .Topptipset .couponInfo button img {
  filter: invert(100%);
}

.Stryktipset .couponInfo button.active, .Europatipset .couponInfo button.active, .Topptipset .couponInfo button.active {
  color: white; 
}

.Stryktipset .couponInfo button.active img, .Europatipset .couponInfo button.active img, .Topptipset .couponInfo button.active img {
  filter: invert(100%);
} */

.couponInfo button img {
  filter: invert(100%);
  height: 10pt;
  vertical-align: text-top;
  justify-content: center;
  align-items: center;
  align-self: center;
  align-content: center;
}

.couponInfo button.active img {
  filter: invert(100%);
  height: 13pt;
}

.couponInfo button.active {
  color: white; 
}

/* .Topptipset {
  background-color: #F29400;
  color: white;
} */

.couponInfo {
  display: flex;
/*   background-color: white;
  border-top: 3px solid black; */
/*  border-width: 5px;
  border-style: double;
  border-bottom: none;
  border-radius: 20pt 20pt 0 0; */
  text-align: center;
  padding: 3px;
  margin: 0 auto;
  width: 100%;
  max-width:863px;
}

.couponInfo button {
  filter: opacity(80%);
  flex: 1;
/*   line-height: 11pt; */
  font-size: 8pt;
  margin: 0 2pt 0 2pt;
  cursor: pointer;
  display: inline-block;
  transition: flex 0.3s ease;
  border: none;
  background: none;
  margin-bottom: 0;
}

.couponInfo button:hover {
  filter: opacity(100%);
}

.couponInfo button.active {
  filter: opacity(100%);
  font-weight: 700;
  font-size: 10pt;
/*   background: rgba(255, 255, 255, 0.5);
  border-radius: 10pt 10pt 10pt 10pt; */
}
  @keyframes wiggle {
    0% { transform: rotate(0deg); }
    25% { transform: rotate(-15deg); }
    75% { transform: rotate(15deg); }
    100% { transform: rotate(0deg); }
  }

  .wiggle {
    animation: wiggle 0.5s ease;
  }

@media (max-width: 768px) {
  .couponInfo button span {
    display:  none;
  }
}

</style>